/**
 * When a product's dose form resolves, the Units/Route fields can be seeded from it. On the edit
 * flow that resolution would overwrite the value already in the field — so decide whether to keep
 * the current value or overwrite it with the derived one.
 *
 * - A `productChanged` resolution always overwrites: the field still holds the *previous* product's
 *   value, which no longer applies.
 * - Otherwise (the initial edit-flow resolve, or a background refetch of the same product) keep the
 *   current value when it is a valid option — a value the form itself wrote round-trips exactly, so
 *   re-deriving it is at best a no-op and at worst discards a choice the user just made. Overwrite
 *   only when the current value isn't an option (legacy clinical text like "Pen Injector" / "Oral
 *   route"), which normalizes it.
 *
 * Keys on the field's *current* value (not the original `initialValues`) so an edit made while the
 * lookup is still in flight is also preserved.
 */
export function shouldPreserveCurrentFieldValue(args: {
  productChanged: boolean;
  currentValue: string | undefined;
  options: readonly string[];
}): boolean {
  const { productChanged, currentValue, options } = args;
  return !productChanged && currentValue !== undefined && options.includes(currentValue);
}
